import axios from 'axios';
import { API_URL } from '../../constants';
import { ErrorResDto, HandleAxiosErrorResDto } from '../error-res.dto';
import type { GetCoachPaymentMethodResDto } from './res/get-coach-payment-method-res.dto';

export class CoachPaymentMethodServer {
  private readonly API_PATH: string = `${API_URL}/coach/payment/method`;

  async get(): Promise<GetCoachPaymentMethodResDto | ErrorResDto> {
    try {
      const response = await axios.get<GetCoachPaymentMethodResDto>(`${this.API_PATH}`);
      return response.data;
    } catch (err) {
      return HandleAxiosErrorResDto(err);
    }
  }
}
